import React from "react";
import { useState } from 'react';
import './Almacenamiento.css';
import imgDiscoDuroExterno from '../../assets/images/discoduro.png';
import imgMemoriaUSB from '../../assets/images/memoriausb.png';
import imgTarjetasSD from '../../assets/images/sd.png';
import imgNAS from '../../assets/images/nas.png';
import imgSSDExterno from '../../assets/images/ssdexterno.png';
import imgCompactFlash from '../../assets/images/compact.png';
import Facebok from '../../assets/images/Facebok.png';
import Wasa from '../../assets/images/Wasa.png';
import insta from '../../assets/images/insta.png';
import Ubi from '../../assets/images/Ubi.png';
import Telefono from '../../assets/images/Telefono.png';
import Email34 from '../../assets/images/Correo.png';
import checkAnim from '../../assets/images/check.gif';
import RedesFondo from '../../assets/images/Red-Neuronal.png';

import { FaWhatsapp } from 'react-icons/fa';
{/* Bloque de menú catalogo Almacenamiento */}
const categoriasAlmacenamiento = [
  {
    //Item 1 catalogo Almacenamiento 
    titulo: 'Discos duros externos',
    img: imgDiscoDuroExterno,
    marcas: ['Western Digital', 'Seagate', 'Toshiba', 'LaCie', 'ADATA'],
  },
  {
    //Item 2 catalogo Almacenamiento 
    titulo: 'Memorias USB',
    img: imgMemoriaUSB,
    marcas: ['SanDisk', 'Kingston', 'PNY', 'Corsair', 'Verbatim'],
  },
  {
    //Item 3 catalogo Almacenamiento 
    titulo: 'Tarjetas SD y microSD',
    img: imgTarjetasSD,
    marcas: ['SanDisk', 'Lexar', 'Samsung', 'Kingston', 'Transcend'],
  },
  {
    //Item 4 catalogo Almacenamiento 
    titulo: 'NAS (nivel usuario básico)',
    img: imgNAS,
    marcas: ['Synology', 'QNAP', 'Western Digital', 'Asustor', 'TerraMaster'],
  },
  {
    //Item 5 catalogo Almacenamiento 
    titulo: 'Unidades SSD externas',
    img: imgSSDExterno,
    marcas: ['Samsung', 'SanDisk', 'Crucial', 'WD', 'ADATA'],
  },
  {
    //Item 6 catalogo Almacenamiento 
    titulo: 'Tarjetas CompactFlash',
    img: imgCompactFlash,
    marcas: ['SanDisk', 'Lexar', 'Transcend', 'Kingston', 'Delkin'],
  },
];


function AlmacenamientoCatalogo() {
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
    }).then(() => {
      setEnviado(true);
      form.reset();
    });
  };

  return (
    <>
    {/* Bloque de inicio catalogo Almacenamiento */}
      <section className="Almacenamiento-white-section">
        <div className="Almacenamiento-header">
          {/*Titulo de catalogo Almacenamiento */}
          <h2 className="Almacenamiento-titulo">Almacenamiento Externo</h2>

          <div className="Almacenamiento-texto-lateral">
            {/*Descripción catalogo Almacenamiento */}
            <p className="Almacenamiento-contacto-descripcion">
              Unidades de almacenamiento externo originales y de alta calidad, ideales para ampliar tu capacidad, realizar respaldos seguros y transferir información de forma eficiente.
            </p>
          </div>
        </div>

        <div className="Almacenamiento-grid">
          {categoriasAlmacenamiento.map((cat, idx) => (
            <div className="Almacenamiento-item" key={idx}>
              <div className="Almacenamiento-img">
                <img src={cat.img} alt={cat.titulo} />
              </div>
              <div className="Almacenamiento-texto">
                <h3>{cat.titulo}</h3>
                <p className="Almacenamiento-marcas">
                  {cat.marcas.map((marca, i) => (
                    <span key={i} className="Almacenamiento-marca-texto">
                      {marca}
                    </span>
                  ))}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="Almacenamiento-contacto">
          {/*Sugerencia whatsapp catalogo Almacenamiento */}
          ¿Buscas una pieza específica? Podemos conseguirla.<br />
           &nbsp;&nbsp;&nbsp;&nbsp;Ponte en contacto con{' '}
          <a
            href="https://wa.me/525567786252"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-link"
          >
            nosotros <FaWhatsapp className="whatsapp-icon-inline" />
          </a>
        </p>
      </section>
    {/* Contenedor principal del formulario de contacto */}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/*Titulo cambiado formulario catalogo Almacenamiento */}
  {!enviado ? (
    <>
    Elige tu solución de almacenamiento externo ideal.<br></br> 
    ¡Cotiza ahora!
    </>
  ) : (
    <>
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      <img src={checkAnim} alt="Éxito" />
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de pagina con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>

  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>

  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* Servicio Consultoria ERP LIBRA colum 2*/}
        <li><a href="/Comercializacion">• Ver mas Infraestructura TI</a></li>
        <li><a href="/">• IAutomatizacion CFDI</a></li>
         
        <li><a href="/Facturacion">• Facturación Electrónica</a></li>
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Sistemas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nostros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         {/*Facturacion Electronica Colum 3*/}
        {/*Servicios Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/* Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
<a
  href="https://wa.me/525567786252"
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-bubble"
>
  <FaWhatsapp size={35} color="#fff" />
</a>
    </>
  );
}


export default AlmacenamientoCatalogo;